var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'grid',
    'items-center',
    _vm.isSchoolLibrary && _vm.isExpanded && ['grid-cols-school-membership-tier-grid'],
    !_vm.isSchoolLibrary && _vm.isExpanded && ['grid-cols-membership-tier-grid', 'gap-y-0'],
    !_vm.isExpanded && ['grid-cols-2', 'gap-y-3', 'auto-rows-min'],
  ]},[_c('div',{staticClass:"order-1"},[_vm._t("first")],2),_vm._v(" "),_c('div',{class:['justify-self-start', _vm.isExpanded && ['order-2'], !_vm.isExpanded && ['order-3', 'self-start']]},[_vm._t("second")],2),_vm._v(" "),(!_vm.isSchoolLibrary)?_c('div',{class:[
      _vm.isExpanded && ['order-3', 'justify-self-start'],
      !_vm.isExpanded && ['order-4', 'self-start', 'justify-self-end'],
    ]},[_vm._t("third")],2):_vm._e(),_vm._v(" "),_c('div',{class:[_vm.isExpanded && ['order-4'], !_vm.isExpanded && ['order-2'], 'justify-self-end']},[_vm._t("fourth")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }